import "./maintenance-mode.scss"
import React, { useEffect, useState } from 'react'
import { Api } from '@shell/shell-ui';
import { fromUnixTime, isAfter, format, isWithinInterval } from 'date-fns';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const MAINTENANCE_STATUS = {
  'planned': 'planned',
  'on_going': 'on_going',
  'invalid': 'invalid'
}

function MaintenanceMode({ children }) {
  const [maintenance, setMaintenance] = useState({});
  const [maintenanceLoading, setMaintenanceLoading] = useState(true);
  const [logoutUrl, setLogoutUrl] = useState('');

  const location = useLocation();
  const user = useSelector((state) => state.user.loggedUser);

  const getMaintenanceInfo = (data) => {
    const { current, from, until } = data;
    if (!from || !until) {
      return {
        text: null,
        status: MAINTENANCE_STATUS.invalid
      }
    }
    const currentDate = fromUnixTime(current);
    const fromDate = fromUnixTime(from);
    const untilDate = fromUnixTime(until);

    const isFromGreaterThanUntil = isAfter(fromDate, untilDate);
    if (isFromGreaterThanUntil) {
      return {
        text: null,
        status: MAINTENANCE_STATUS.invalid
      }
    }
    const isFromGreaterThanCurrent = isAfter(fromDate, currentDate);
    const isCurrentWithinInterval = isWithinInterval(currentDate, { start: fromDate, end: untilDate });

    if (isFromGreaterThanCurrent) {
      return {
        text: `The planned maintenance work is scheduled from ${format(fromDate, 'd/L/y H:mm')} CEST to  ${format(untilDate, 'd/L/y H:mm')} CEST`,
        status: MAINTENANCE_STATUS.planned
      }
    }
    if (isCurrentWithinInterval) {
      if (logoutUrl && !location.pathname.includes('/login') && !user?.userRoles?.includes('ROLE_SUPER_ADMIN')) {
        window.location.replace(logoutUrl);
      }
      return {
        text: `The planned maintenance work is ongoing until ${format(untilDate, 'd/L/y H:mm')} CEST`,
        status: MAINTENANCE_STATUS.on_going
      }
    }
    return {
      text: null,
      status: MAINTENANCE_STATUS.invalid
    }
  }
  useEffect(()=> {
    const getLogOutUrl = async () => {
      try {
      const { data } = await Api.get('/logout/service');
        setLogoutUrl(data)
      } catch (error) {
        toast.error('Unable to retrieve logout url');
      }
    }
    if (user) {
      getLogOutUrl();
    }
  }, [!!user]);

  useEffect(() => {
    async function getMaintenanceTime() {
      try {
        const { data } = await Api.get('maintenance/time');
        setMaintenance({
          current: data.current,
          from: data.from,
          until: data.until,
        })
      } catch (e) {
        console.log({ e })
      }
    }
    getMaintenanceTime().then(()=> {
      setMaintenanceLoading(false)
    })
  }, []);

  const isAuthenticatedUser = user && logoutUrl;
  const isUnAuthenticatedUser = !user;

  if ((isAuthenticatedUser && !maintenanceLoading )|| (isUnAuthenticatedUser && !maintenanceLoading)) {
    const { status, text } = getMaintenanceInfo(maintenance);
    return (
      <>
        <div className='maintenance-mode' data-maintenance-status={status}>
          {!!text && (
            <div className='maintenance-mode__bar'>
              {text}
            </div>
          )}
          {children}
        </div>
      </>
    )
  }
  return null;
}

export default MaintenanceMode
